import { render, staticRenderFns } from "./IntroVideoComponent.vue?vue&type=template&id=9d3a4a50"
import script from "./IntroVideoComponent.vue?vue&type=script&lang=js"
export * from "./IntroVideoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports